import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';
import { FileData } from '../pages/job-manager/components/create-job-dialog';

interface PostImportGlossaryMetadataProps {
    file: FileData;
    token: string;
    email?: string;
    fileType: string;
}
export const postImportGlossaryMetadata: MutationFunction<
    AxiosResponse<any>,
    PostImportGlossaryMetadataProps
> = async (props: PostImportGlossaryMetadataProps) => {
    const { token, email, file, fileType } = props;
    const headers = getDefaultHeaders(token);
    const importGlossaryMetadataUrl = `/metadata/glossary/import`;

    const formData = new FormData();
    const response = await fetch(file.url);
    const blob = await response.blob();
    formData.append('fileType', fileType);
    formData.append('file', blob, file.name);
    if (email) {
        formData.append('emailResultsTo', email);
    }

    return axiosInstance().post(
        importGlossaryMetadataUrl,
        formData,
        withHeaders(headers)
    );
};
export const useImportGlossaryMetadata = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostImportGlossaryMetadataProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();
    return useMutation(postImportGlossaryMetadata, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                'Glossary imported.'
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to import glossary metadata';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
